var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustraliaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "australia-flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M0 0h48v32h-48v-32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M20.942 16v0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M17.739 19.931l1.028 2.148 2.32-0.533-1.038 2.142 1.865 1.479-2.324 0.524v2.38l-1.858-1.49-1.849 1.486v-2.38l-2.324-0.524 1.865-1.479-1.038-2.142 2.311 0.533z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M36.288 22.599l0.491 1.024 1.106-0.256-0.496 1.022 0.889 0.711-1.108 0.249v1.136l-0.889-0.711-0.889 0.711v-1.136l-1.108-0.249 0.889-0.711-0.496-1.022 1.106 0.256z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M31.73 11.73l0.491 1.024 1.106-0.256-0.496 1.022 0.889 0.711-1.108 0.249v1.136l-0.889-0.711-0.889 0.711v-1.136l-1.108-0.249 0.889-0.711-0.496-1.022 1.106 0.256z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M36.288 5.522l0.491 1.024 1.106-0.256-0.496 1.022 0.889 0.711-1.108 0.249v1.136l-0.889-0.711-0.889 0.711v-1.136l-1.108-0.249 0.889-0.711-0.496-1.022 1.106 0.256z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M40.27 10.176l0.491 1.024 1.106-0.256-0.496 1.022 0.889 0.711-1.108 0.249v1.136l-0.889-0.711-0.889 0.711v-1.136l-1.108-0.249 0.889-0.711-0.496-1.022 1.106 0.256z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M37.422 15.612l0.386 1.186h1.244l-1.010 0.732 0.386 1.186-1.010-0.732-1.010 0.732 0.386-1.186-1.010-0.732h1.244z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M24 0v2.864l-4.235 2.354h4.235v5.568h-5.541l5.541 3.076v2.133h-2.501l-6.891-3.822v3.828h-5.216v-4.555l-8.197 4.555h-1.195v-2.864l4.235-2.35h-4.235v-5.564h5.541l-5.541-3.083v-2.133h2.501l6.891 3.828v-3.833h5.216v4.553l8.197-4.553z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M13.5 0h-3.001v6.5h-10.5v3.001h10.5v6.5h3.001v-6.5h10.5v-3.001h-10.5z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M14.608 10.782l9.392 5.218v-1.476l-6.736-3.733z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M14.608 10.782l9.392 5.218v-1.476l-6.736-3.733z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M14.608 10.782l9.392 5.218v-1.476l-6.736-3.733z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M6.736 10.782l-6.736 3.742v1.476l9.392-5.218z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "M9.392 5.218l-9.392-5.218v1.476l6.736 3.733z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M9.392 5.218l-9.392-5.218v1.476l6.736 3.733z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M9.392 5.218l-9.392-5.218v1.476l6.736 3.733z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M17.264 5.218l6.736-3.733v-1.476l-9.392 5.218z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaFlag);
export default __webpack_public_path__ + "static/media/australia-flag.fe22b211a22d433df516611677e6c51a.svg";
export { ForwardRef as ReactComponent };